import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { useAcademyHomeUrl } from '~/composables/academy/useAcademyHomeUrl';
import { ACADEMY_CONSENT_PENDING_SEGMENT } from '~/utils/academyConsentPendingPath';

/**
 * Locale-prefixed path of the consent waiting page, e.g. `/de-de/academ/consent-pending`. Shared by
 * the Self Service `postsave-callback` and the page's own route definition.
 */
export const useAcademyConsentPendingUrl = (route?: RouteLocationNormalizedGeneric) => {
    const academyHomeUrl = useAcademyHomeUrl(route);

    return computed(() => {
        /** The home path ends with a slash when the Academy sits at the country root. */
        const base = academyHomeUrl.value;

        return `${base.endsWith('/') ? base.slice(0, -1) : base}/${ACADEMY_CONSENT_PENDING_SEGMENT}`;
    });
};
